import React from 'react';
import autoBind from 'react-autobind';
import ApplicationAction from '../../actions/ApplicationActions';
import _ from 'lodash';

export default class SectionHeader extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    handlePencilClick() {
        ApplicationAction.editSection(this.props.sectionId);
        if (this.props.handlePencilClick){
            this.props.handlePencilClick();
        }
    }

    renderSectionParagrahps() {
        let paragraphs = _.map(this.props.sectionParagraphs,
            function(p, idx) {
                return (<h5 key={idx}>{p}</h5>);
            });
        return paragraphs;
    }

    render() {
        const sectionMessage = this.props.sectionMessage ? <h5>{this.props.sectionMessage}</h5> : null;
        return (
            <div className="row confirm-section-header">
                <div className="col-xs-10">
                    <h4>{this.props.sectionName}</h4>
                    <span className="confirm-section-header__message">
                        {sectionMessage}
                        {this.renderSectionParagrahps()}
                    </span>
                </div>
                <div className="col-xs-1 col-sm-2 workItem__hidden">
                    <span className="pull-right section-header-edit">
                        <a href="javascript:void(0);" onClick={this.handlePencilClick} sectionName="Edit"><i className="icon icon-pencil"></i></a>
                    </span>
                </div>
            </div>
        )
    }
}

SectionHeader.propTypes = {
    sectionName: React.PropTypes.string.isRequired,
    sectionMessage: React.PropTypes.string,
    sectionParagraphs: React.PropTypes.array
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails/SectionHeader.jsx